import {
  SUPPORTED_LOCALES,
  SupportedLocale,
} from '@goeuro/app/client/fe-utils/src/localization/languages';

type LocaleCode = SupportedLocale | 'en-GB' | 'en-SG' | 'pt-BR';

export interface Locale {
  code: LocaleCode;
  flag: string;
  label: string;
}

const mappedLocale: Record<LocaleCode, Omit<Locale, 'code'>> = {
  bg: { flag: 'bg', label: 'Bulgarian' },
  cs: { flag: 'cz', label: 'Czech' },
  ca: { flag: 'es', label: 'Catalan' },
  da: { flag: 'dk', label: 'Danish' },
  de: { flag: 'de', label: 'German' },
  el: { flag: 'gr', label: 'Greek' },
  en: { flag: 'us', label: 'English' },
  'en-GB': { flag: 'gb', label: 'English (UK)' },
  'en-SG': { flag: 'sg', label: 'English (Singapore)' },
  es: { flag: 'es', label: 'Spanish' },
  fi: { flag: 'fi', label: 'Finnish' },
  fr: { flag: 'fr', label: 'French' },
  hr: { flag: 'hr', label: 'Croatian' },
  hu: { flag: 'hu', label: 'Hungarian' },
  it: { flag: 'it', label: 'Italian' },
  ja: { flag: 'jp', label: 'Japanese' },
  km: { flag: 'kh', label: 'Khmer' },
  ko: { flag: 'kr', label: 'Korean' },
  nb: { flag: 'no', label: 'Norwegian' },
  nl: { flag: 'nl', label: 'Dutch' },
  pl: { flag: 'pl', label: 'Polish' },
  pt: { flag: 'pt', label: 'Portuguese' },
  'pt-BR': { flag: 'br', label: 'Portuguese (Brazil)' },
  ro: { flag: 'ro', label: 'Romanian' },
  ru: { flag: 'ru', label: 'Russian' },
  sv: { flag: 'se', label: 'Swedish' },
  th: { flag: 'th', label: 'Thai' },
  tr: { flag: 'tr', label: 'Turkish' },
  uk: { flag: 'ua', label: 'Ukrainian' },
  vi: { flag: 'vn', label: 'Vietnamese' },
  zh: { flag: 'cn', label: 'Chinese' },
  ms: { flag: 'my', label: 'Melayu' },
  id: { flag: 'id', label: 'Indonesian' },
};

export const locales: Locale[] = SUPPORTED_LOCALES.map(locale => ({
  code: locale,
  ...mappedLocale[locale],
}));

export const defaultLocale: Locale = {
  code: 'en',
  flag: 'us',
  label: 'English (US)',
};

export const localeToFlagSrc = (locale: LocaleCode) =>
  `https://assets.omio.design/flags/svg/${mappedLocale[locale].flag}~src.svg`;

export const listLocaleCodes = () => locales.map(({ code }) => code);
